<template>
<div>
    <div id="Menu">
        <div class="btn-menu"><img src="../../common/images/common/btn_menu.png" width="41" height="41" alt="MENU"></div>
        <div class="menu__box">
        <ul>
            <li><strong><a href="/" v-bind:title="$t('thHome')">{{$t('thHome')}}</a></strong></li>
            <li><strong><a href="/company" v-bind:title="$t('tlCompany')" :class="selectedid == 'tlCompany' ? 'active': ''">{{$t('tlCompany')}}</a></strong></li>
            <li><strong><a href="/products" v-bind:title="$t('tlProductCenter')" :class="selectedid == 'tlProductCenter' ? 'active': ''">{{$t('tlProductCenter')}}</a></strong></li>
            <li><strong><a href="/service" v-bind:title="$t('tlService')" :class="selectedid == 'tlService' ? 'active': ''">{{$t('tlService')}}</a></strong></li>
            <li><strong><a href="/media" v-bind:title="$t('tlMediaCenter')" :class="selectedid == 'tlMediaCenter' ? 'active': ''">{{$t('tlMediaCenter')}}</a></strong></li>
            <li><strong><a href="mailto:info@arivotyre.com?subject=Test Email" v-bind:title="$t('tlContact')" class="ico-mail">{{$t('tlContact')}}</a></strong></li>
        </ul>
        </div>
    </div>
</div>
</template>

<script>

var $ = require("jquery");
$(function() {
  $("#Menu .menu__box");
  $("#Menu .btn-menu").click(function() {
    $(this)
      .toggleClass("open")
      .next()
      .slideToggle("fast");
  });
});

export default {
    name: "SiteMenu",
    props: ['selectedid']
}
</script>



// WEBPACK FOOTER //
// src/components/common/sitemenu.vue